import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { allPages } from "../pages/pageContents";
import ReactMarkdown from "react-markdown";
import Markdown from "react-markdown";
import AIChatbotUI from "./AIChatbotUI";

function shuffle(arr) {
    var j, x, index;
    for (index = arr.length - 1; index > 0; index--) {
        j = Math.floor(Math.random() * (index + 1));
        x = arr[index];
        arr[index] = arr[j];
        arr[j] = x;
    }
    return arr;
}

function AISearchResultsPage(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const questions = require("../contents/questions.json");
    const source = require(`../contents/${props.source}.json`);
    const [inputQuery, setInputQuery] = useState("");
    const [displayedQuery, setDisplayedQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const quiz = questions[(props?.question || 1) - 1];
    const [currentPage, setCurrentPage] = useState(0);
    const resultsPerPage = 4;

    const startIndex = currentPage * resultsPerPage;
    const endIndex = startIndex + resultsPerPage;
    const maxPage = Math.ceil(searchResults.length / resultsPerPage);
    const paginatedResults = searchResults.slice(startIndex, endIndex);
    const backgroundImage = quiz.image
        ? `url('/image/${quiz.image}')`
        : "url('https://images.unsplash.com/photo-1736077722346-31ba59414728?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')";

    useEffect(() => {
        const q = props.searchQuery;
        setInputQuery(q);
        setDisplayedQuery(q);
        performSearch(q);
    }, [location.search]);

    const performSearch = () => {
        const processedResults = [...Object.entries(source[props.question]["A"]), ...Object.entries(source[props.question]["B"])].map(
            ([key, res]) => {
                console.log(res);
                const lines = res.split("\n");
                const title = lines[0].replace(/#/g, "").replace(/\*/g, "");
                const snippet = res
                    .split("\n")
                    .slice(1)
                    .join(" ")
                    .replace(/[#_*~`>]/g, "")
                    .substring(0, 1000);
                return { id: key, title, snippet, bodyText: res.split("\n").slice(1).join("\n") };
            }
        );

        setSearchResults(processedResults);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        //navigate(`/search?q=${encodeURIComponent(inputQuery)}`);
        setDisplayedQuery(inputQuery);
        performSearch(inputQuery);
    };

    const [expandedResult, setExpandedResult] = useState(null);

    const toggleExpand = (id) => {
        setExpandedResult(expandedResult === id ? null : id);
    };

    return (
        <div className="relative h-screen w-full flex flex-col items-center bg-gray-50">
            {/* Background Image with Fade */}
            <div className="absolute top-0 left-0 w-full h-1/4 bg-cover bg-center" style={{ backgroundImage }}>
                <div className="w-full h-full bg-gradient-to-b from-transparent to-gray-50"></div>
            </div>

            {/* Content Container */}
            <div className="relative flex flex-col items-center justify-center mt-20 max-w-6xl w-full">
                {/* Generative X Label */}
                <div className="flex justify-start w-full mt-20 mb-8 text-gray-600 font-medium text-lg">
                    <div className="mx-4">Generative X</div>
                </div>

                {props.source == "HBLE" || props.source == "LBLE" ? (
                    <p className="mx-4">
                        After receiving your search inquiry, the Beta version of Generative X will respond with search results ONLY collected from
                        MIT Technology Review based on your inquiry
                    </p>
                ) : null}

                <div className="flex justify-end w-full mb-8 mt-2">
                    <div className="bg-gray-200 rounded-xl mx-4 py-3 px-5 max-w-[70%]">You asked about {quiz.theme}.</div>
                </div>

                {searchResults.length === 0 ? (
                    <p>No results found.</p>
                ) : (
                    <div className={searchResults.length === 1 ? "p-0 w-full" : "p-0 w-full"}>
                        {paginatedResults.map((result) => (
                            <div
                                onClick={() => toggleExpand(result.id)}
                                className={"bg-white mb-6 shadow p-4 mx-4 rounded " + (searchResults.length === 1 ? "max-w-6xl" : "max-w-2xl")}
                                key={result.id}
                            >
                                <div className="cursor-pointer flex items-center justify-between">
                                    <h3 className="text-2xl font-medium my-1">
                                        <ReactMarkdown>{result.title}</ReactMarkdown>
                                    </h3>
                                    {paginatedResults.length == 1 ? null : <span>{expandedResult === result.id ? "▲" : "▼"}</span>}
                                </div>
                                {expandedResult === result.id || paginatedResults.length === 1 ? (
                                    <div>
                                        <AIChatbotUI text={result.bodyText} />
                                    </div>
                                ) : (
                                    <p className="p-0 mx-2 my-0 line-clamp-2">{result.snippet}</p>
                                )}
                            </div>
                        ))}

                        {searchResults.length > resultsPerPage ? (
                            <div className="flex justify-between mt-4 w-full">
                                <button
                                    disabled={currentPage === 0}
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                    className={`px-4 py-2 bg-gray-300 text-gray-800 rounded border-none ${
                                        currentPage === 0 ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                >
                                    Previous Page
                                </button>
                                {
                                    <div className="items-center">
                                        {Array.from({ length: maxPage }, (_, i) => (
                                            <button
                                                key={"page_button_" + i}
                                                onClick={() => setCurrentPage(i)}
                                                className={`px-3 py-1 mx-1 rounded border-none ${
                                                    currentPage === i ? "text-gray-800" : "bg-transparent text-blue-600"
                                                }`}
                                            >
                                                {i + 1}
                                            </button>
                                        ))}
                                    </div>
                                }

                                <button
                                    disabled={endIndex >= searchResults.length}
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                    className={`px-4 py-2 bg-blue-600 text-white rounded border-none ${
                                        endIndex >= searchResults.length ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                >
                                    Next Page
                                </button>
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
}

export default AISearchResultsPage;
